// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".controls-button{border:none;background-color:transparent;cursor:pointer;padding:0}.controls-button.padded{padding:.5rem}.controls-button__inner{position:absolute;width:100%;height:auto}.controls-button.padded .controls-button__inner{width:calc(100% - 1rem)}.controls-button.bottom .controls-button__inner{bottom:0;left:50%;transform:translateX(-50%)}.controls-button.center .controls-button__inner{top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
